<div class="chart-display-parent">
  <div class="chart-display-child"></div>
</div>